import { useConditionStore } from "../condition/conditions.store";
import { getImageCopyData } from "../image/imageFunctions";
import { useImageStore } from "../image/images.store";
import type { ScenarioEndItem } from "./ScenarioEndItem";

export function getScenarioEndCopyData(scenarioEnd: ScenarioEndItem) {
  const data = [];

  data.push(scenarioEnd);

  // copy image
  if (scenarioEnd.imageId) {
    const imageStore = useImageStore();
    const image = imageStore.items[scenarioEnd.imageId];
    data.push(...getImageCopyData(image));
  }

  // add conditions
  // conditions should be copied AFTER the scenarioEnd,
  // so that the copied conditions are linked to the copied scenarioEnd
  const conditionStore = useConditionStore();
  const conditions = conditionStore.getBySource(scenarioEnd);
  for (const condition of conditions) {
    data.push(condition);
  }

  return data;
}
